/**
 *
 * Jit Requests
 *
 */
import React from 'react';

import { DecisionStatus } from '@ariksa/jit/api';
import { Box, HStack, Stack } from '@chakra-ui/react';

import { Card, PageHeaderWithIcon } from 'components/DataDisplay';
import { BorderedBox } from 'components/DataDisplay/Box/BorderedBox';
import { FilterLabelWrapper } from 'components/DataDisplay/Box/BorderedBox/FilterLabelWrapper';
import { ButtonGroup, ButtonGroupItem, Select } from 'components/DataEntry';
import { NotifyIcon } from 'components/Icons';
import { JitRequestsTable } from 'containers/Jit/JitRequests/Components/JitRequestsTable';
import { MyRequests } from 'containers/Jit/JitRequests/Components/MyRequests';
import { useInjector } from 'utils/inject';

import {
  jitPendingStatusOption,
  jitStatusOptions,
} from './Components/utils';
import { jitRequestsSaga } from './saga';
import { reducer, sliceKey } from './slice';

export const JitRequests = () => {
  useInjector(sliceKey, reducer, jitRequestsSaga);

  const jitViewByOptions = [
    { label: 'My Requests', value: 'requests' },
    { label: 'My Approvals', value: 'approvals' },
  ];

  const [viewBy, setViewBy] = React.useState<ButtonGroupItem>(
    jitViewByOptions[0],
  );
  const [status, setStatus] = React.useState(jitStatusOptions[0]);

  // Each view opens on the filter that view is for: an approver comes here to
  // clear the queue, a requester to see everything they have raised.
  React.useEffect(() => {
    setStatus(
      viewBy.value === 'approvals' ? jitPendingStatusOption : jitStatusOptions[0],
    );
  }, [viewBy]);

  return (
    <Card styles={{ card: { h: 'full' } }}>
      <Stack h="full" spacing={5} w="full">
        <HStack w="full" justify="space-between">
          <PageHeaderWithIcon label="JIT Requests" icon={<NotifyIcon />} />
        </HStack>
        <BorderedBox>
          <HStack>
            <FilterLabelWrapper>VIEW BY</FilterLabelWrapper>
            <ButtonGroup
              items={jitViewByOptions}
              value={viewBy}
              onClick={setViewBy}
            />
            <FilterLabelWrapper ml={3}>FILTER BY</FilterLabelWrapper>
            <Box>
              <Select
                options={jitStatusOptions}
                value={status}
                onChange={setStatus}
                menuPortalTarget={document.body}
                isAFilter
                leftMessage="Status"
                showUndefinedValueLabel={false}
              />
            </Box>
          </HStack>
        </BorderedBox>
        {viewBy.value === 'requests' ? (
          <MyRequests decisionStatus={status?.value as DecisionStatus} />
        ) : (
          <JitRequestsTable
            viewBy={viewBy.value}
            decisionStatus={status?.value as DecisionStatus}
          />
        )}
      </Stack>
    </Card>
  );
};
